import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type LogbookTaskFilterProps = {
	value: string;
	onChange: (value: string) => void;
};

export const LogbookTaskFilter = ({ value, onChange }: LogbookTaskFilterProps) => {
	return (
		<FormControl size="small" sx={{ minWidth: 100, maxWidth: 400, flex: 1 }}>
			<InputLabel>Tarefas</InputLabel>
			<Select
				value={value}
				label="Tarefas"
				onChange={(e) => onChange(e.target.value)}
			>
				<MenuItem value="all">Todas as tarefas</MenuItem>
				<MenuItem value="open">Tarefas abertas</MenuItem>
				<MenuItem value="done">Tarefas concluídas</MenuItem>
				<MenuItem value="hide">Não mostrar tarefas</MenuItem>
			</Select>
		</FormControl>
	);
};
